import { observer } from 'mobx-react-lite'
import { Suspense, useEffect } from 'react'
import { Outlet, useLocation } from 'react-router'
import { useCbuAutoLoad } from '@/features/finance/CbuRates'
import { useT } from '@/i18n'
import { cn } from '@/lib/cn'
import { useStores } from '@/stores'
import { CommandPalette } from './CommandPalette'
import { LeaveGuardHost } from './LeaveGuardHost'
import { PageFallback } from './PageFallback'
import { useRecordRecentPage } from './recentPages'
import { Sidebar } from './Sidebar'
import { Topbar } from './Topbar'
import { usePresenceHeartbeat } from './usePresenceHeartbeat'
import { TopNav } from './TopNav'

export const AppShell = observer(function AppShell() {
  const { ui, appearance } = useStores()
  const { sidebarSide, contentWidth } = appearance.settings
  const t = useT()
  const location = useLocation()

  useEffect(() => {
    ui.setMobileNav(false)
  }, [location.pathname, location.search, ui])
  useRecordRecentPage()
  usePresenceHeartbeat()
  useCbuAutoLoad()

  return (
    <div className={cn('flex h-dvh gap-3 p-2 sm:p-3', sidebarSide === 'right' && 'flex-row-reverse')}>
      <a href="#main" className="sr-only focus:not-sr-only focus:absolute focus:left-4 focus:top-4 focus:z-[90] focus:rounded-lg focus:bg-ink focus:px-3 focus:py-2 focus:text-ink-fg">
        {t('layout.skipToContent')}
      </a>
      {sidebarSide !== 'top' && <Sidebar />}
      <div className="flex min-w-0 flex-1 flex-col gap-2.5">
        {sidebarSide === 'top' ? <TopNav /> : <Topbar />}
        <main id="main" className="flex min-h-0 flex-1 flex-col overflow-y-auto px-0.5 pb-1 pt-1.5 sm:px-1.5">
          {/* Keyed by path: each page rises in; query-only changes (filters, sheet) don't replay it. */}
          <div key={location.pathname} className={cn('animate-page-in flex min-h-0 flex-1 flex-col', contentWidth === 'limited' && 'mx-auto w-full max-w-[1240px]')}>
            <Suspense fallback={<PageFallback />}>
              <Outlet />
            </Suspense>
          </div>
        </main>
      </div>
      <CommandPalette />
      <LeaveGuardHost />
    </div>
  )
})
